import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.string.match-all.js";
/*
 * Parse Search
 */
export default function parseSearch() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var handler = arguments.length > 1 ? arguments[1] : undefined;
  // split this into quoted and non-quoted parts
  var matches = str.matchAll(
  // eslint-disable-next-line security/detect-unsafe-regex
  /\s*((not |-|not:)?([._a-z-]+):(?!\/\/)\s*)?(((\s*,\s*)?(".*?"|[^\s,]+))+)/gi);

  // Convert Regex Iterator to an Array and process
  return _toConsumableArray(matches).map(function (match) {
    var _match = _slicedToArray(match, 5),
      _match$ = _match[2],
      rawNegate = _match$ === void 0 ? false : _match$,
      _match$2 = _match[3],
      rawKey = _match$2 === void 0 ? 'text' : _match$2,
      rawValue = _match[4];
    var key = rawKey;
    var negate = !!rawNegate;

    // Cast negate to a Boolean;
    negate = Boolean(negate);
    var value = [];
    if (key === 'is' || key === 'has') {
      key = rawValue;
    } else if (key === 'not' || key === 'no') {
      key = rawValue;
      negate = !negate;
    } else {
      // Extract each value from the comma separated list
      value = _toConsumableArray(rawValue.matchAll(/(".*?"|[^\s,]+)/gi)).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          a = _ref2[0];
        return a.replace(/^(["'])(.*)\1$/, '$2');
      });
    }
    if (handler) {
      // Match lowercase keys
      var keyProp = key.toLowerCase();

      // Remove the trailing `s` to match pluralized keys
      var singularKey = keyProp.match(/s$/i) && keyProp.replace(/s$/i, '');
      var func = handler[keyProp] || singularKey && handler[singularKey] || (handler === null || handler === void 0 ? void 0 : handler.default);
      if (func) {
        func.call(handler, value, negate ? '-' : '', key);
      }
    }
    return {
      key: key,
      value: value,
      negate: negate
    };
  });
}

/*
 * If there is only one item in the array return it, otherwise return the array
 */
export function orOnly(obj) {
  return Array.isArray(obj) && obj.length === 1 ? obj[0] : obj;
}

/*
 * Export the search parser
 * This is used to create a search string
 * Given an array of values `First, -Last, email@example.com, Multi word value`
 * This would create a search string like `+First* -Last* +"email@example.com" +"Multi word value"`
 */
export function parseFullTextSearch(values, negate) {
  var _values$;
  var prev = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  // Should this pattern cause an inclusion in the results or an exclusion?
  var prefix = negate || ((_values$ = values[0]) !== null && _values$ !== void 0 && _values$.startsWith('-') ? '-' : '+');
  var formattedSearches = values.map(function (str) {
    // Remove any prefix operator from the search term
    str = str.replace(/^-/, '');

    // If the string is empty, ignore it
    if (str.length === 0) {
      return '';
    }

    // Should we quote the string? If it contains any of the following characters it can break sql request
    // This part should be moved to the backend
    return /[\s%'()*+-@~]/.test(str) ? "\"".concat(str, "\"") : "".concat(str).concat(prefix !== '-' ? '*' : '');
  });
  var textsearch = formattedSearches.length > 1 ? "".concat(prefix, "(").concat(formattedSearches.join(' '), ")") : "".concat(prefix).concat(formattedSearches[0]);
  return "".concat(textsearch, " ").concat(prev).trim();
}